import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  posts: [],
  selectedPost: null,
  isModalOpen: false,
  filters: {
    tags: [],
    search: '',
  },
  loading: false,
  error: null,
};

const blogSlice = createSlice({
  name: 'blog',
  initialState,
  reducers: {
    setPosts: (state, action) => {
      state.posts = action.payload;
    },
    setSelectedPost: (state, action) => {
      state.selectedPost = action.payload;
      state.isModalOpen = !!action.payload;
    },
    closeModal: (state) => {
      state.selectedPost = null;
      state.isModalOpen = false;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  setPosts,
  setSelectedPost,
  closeModal,
  setFilters,
  setLoading,
  setError,
} = blogSlice.actions;

export default blogSlice.reducer; 